import { pluralize } from './textFormatters';

// Ex: "1 seconde", "1 minute et 54 secondes", "1 heure, 14 minutes et 12 secondes"
export const formatElapsedDuration = (elapsedSeconds: number) => {
  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  const secondsLabel = pluralize(seconds, { one: '# seconde', other: '# secondes' });
  if (elapsedSeconds < 60) return secondsLabel;

  const minutesLabel = pluralize(minutes, { one: '# minute', other: '# minutes' });
  if (elapsedSeconds < 3600) return `${minutesLabel} et ${secondsLabel}`;

  const hoursLabel = pluralize(hours, { one: '# heure', other: '# heures' });
  return `${hoursLabel}, ${minutesLabel} et ${secondsLabel}`;
};
